import { IAddCustomerState } from '@zet/utils/interface'
import { create } from 'zustand'

const useAddCustomerStore = create<IAddCustomerState>((set) => ({
  customerPhoneNumber: '',
  setCustomerPhoneNumber: (payload) =>
    set((state) => ({ ...state, customerPhoneNumber: payload })),
  customerName: '',
  setCustomerName: (payload) =>
    set((state) => ({ ...state, customerName: payload })),
  customerId: 0,
  setCustomerId: (payload) =>
    set((state) => ({ ...state, customerId: payload })),
  hashAfterOtp: '',
  setHashAfterOtp: (payload) =>
    set((state) => ({ ...state, hashAfterOtp: payload })),
  panAfterVerify: '',
  setPanAfterVerify: (payload) =>
    set((state) => ({ ...state, panAfterVerify: payload })),
  nameAsPerPan: '',
  setNameAsPerPan: (payload) =>
    set((state) => ({ ...state, nameAsPerPan: payload })),
  disableBankNameFieldWhenCash: false,
  setDisableBankNameFieldWhenCash: (payload) =>
    set((state) => ({ ...state, disableBankNameFieldWhenCash: payload })),
  brandSpecificPartnerId: null,
  setBrandSpecificPartnerId: (payload) =>
    set((state) => ({ ...state, brandSpecificPartnerId: payload })),
  webFlowLocale: 'en',
  setWebFlowLocale: (payload) =>
    set((state) => ({ ...state, webFlowLocale: payload })),
  isReconcentFlowOtpVerify: false,
  setIsReconcentFlowOtpVerify: (payload) =>
    set((state) => ({ ...state, isReconcentFlowOtpVerify: payload })),
  isWebFlow: false,
  setIsWebFlow: (payload) => set((state) => ({ ...state, isWebFlow: payload })),
  variantId: 0,
  setVariantId: (payload) => set((state) => ({ ...state, variantId: payload })),
}))

export default useAddCustomerStore
